<template>
  <div>

    <div class="container">


      <div class="container container-fixed">
        <div class="position-relative">
          <img class="arrow-right" src="../assets/images/right-btn.png"
               @click="$router.push({ path: '/formula-lapte-praf-aptamil' })">
          <img class="arrow-left" src="../assets/images/left-btn.png"
               @click="$router.push({ path: '/secretele-laptelui-matern' })">
        </div>
      </div>
    </div>

    <div class="mobile-banner" v-if="mobile_component">
      <div class="main-page-banner">
        <banner></banner>

      </div>
    </div>
    <div v-else class="container container-imunitate">

      <banner></banner>
    </div>


    <div class="container position-relative">


      <div class="row doctor-container">
        <div class=" col-12 col-md-4 doctor-info">
          <div class="doctor-img">
            <img src="../assets/images/pentru-imunitate/img-medic-desktop.png">

          </div>
          <div class="name-doctor">
            <h2>Dr. Elena Camelia Berghea <br><span>Medic Primar Alergologie <br> Imunologie Clinică</span>
            </h2>
          </div>
        </div>
        <div class="col-12 col-md-8">
          <p>Ca mamă, vrei pentru copilul tău imunitate de fier, nu-i așa? Ți-am pregătit un mini-ghid de imunitate în
            primii ani de viață. Află ce este sistemul imunitar și cum poate fi susținut în perioada copilăriei. </p>
        </div>
      </div>
    </div>
    <div class="section-doctor-mobile">
      <div class="col-lg-10 offset-lg-1">
        <div class="icon-doctor">
          <div class="row align-items-center container">
            <div class="col-3 pl-0">
              <img src="../assets/images/pentru-imunitate/img-medic-desktop.png">
            </div>
            <div class="col-9" style="padding: 0">
              <div class="name-doctor">
                <h2>Dr. Elena Camelia Berghea <br><span>Medic Primar Alergologie <br> Imunologie Clinică</span>
                </h2>
              </div>
            </div>
            <div class="col-12" style="padding: 0">
              <div class="collapse" id="moreDoctor">
                <p>Ca mamă, vrei pentru copilul tău imunitate de fier, nu-i așa? Ți-am pregătit un mini-ghid de
                  imunitate în
                  primii ani de viață. Află ce este sistemul imunitar și cum poate fi susținut în perioada
                  copilăriei. </p>

              </div>
              <div class="text-center">
                <a class="more-mobil mb-2" data-toggle="collapse" href="#moreDoctor" role="button"
                   aria-expanded="false" aria-controls="moreDoctor" @click="actionTricks()">
                  <span v-if="!show_more">Află  mai multe </span>
                  <span v-else>Află  mai puține</span>
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="imunitate-one">
      <div class="imunitate mt-0">

        <div class="row">
          <div class="col-12">
            <ce-este></ce-este>
          </div>
        </div>

      </div>
    </div>

    <div>
      <div class="imunitate">
        <div class="row">
          <div class="col-12">
            <imunitate-scazuta></imunitate-scazuta>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <check-imunitate></check-imunitate>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="imunitate">
        <div class="bannerAlergii">
          <div class="container">
            <h1>Ce sunt alergiile și <br> ce legătură au cu imunitatea?</h1>
          </div>
        </div>
        <div>
          <div class="row">
            <div class="col-12">
              <div class="secret-white ">
                <div class="container secret-container">
                  <div class="row">
                    <div class="secret--container-quote col-2">
                      <img src="../assets/images/image-secretele-laptelui/quote.png" alt="/">
                    </div>
                    <div class="secret--container-content  col-10">
                      <p>Alergia este o reacție imunitară exagerată, atunci când organismul
                        consideră un factor inofensiv (alergen) ca fiind periculos</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="row">
            <div class="col-lg-10 offset-lg-1">
              <p class="py-3"> Printre cei mai frecvenți <span class="blue-two">factori de risc</span>
                în dezvoltarea alergiilor se află:
              </p>
              <alergii></alergii>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div>
      <div class="imunitate">
        <div class="row">
          <div class="col-12">
            <intarirea-sistemului></intarirea-sistemului>
          </div>
        </div>
      </div>
    </div>


    <div class="">
      <div class="imunitate">
        <div class="row">
          <div class="col-lg-10 offset-lg-1">
            <dezvoltarea-imunitatii></dezvoltarea-imunitatii>
          </div>
        </div>
      </div>

      <slider-one v-if="mobile_component"></slider-one>
      <div class="container" v-else>
        <div class="component-container">
          <nastere-naturala></nastere-naturala>
          <alaptarea></alaptarea>
          <expunerea></expunerea>
          <vaccinare></vaccinare>
        </div>

      </div>
    </div>

    <div class="mt-5">
      <div class="banner-lapte">
        <div class="offset-lg-1">
          <div class="container">
            <h1>Ce rol are laptele matern<br> in imunitate?</h1>
          </div>
        </div>
      </div>
      <div class="container pt-5">
        <div class="row">
          <div class="col-lg-10 offset-lg-1 px-md-1 pb-30">
            <laptele-matern></laptele-matern>
          </div>
        </div>
      </div>
    </div>


    <section class="nutrienti pt-30">
      <div class="container text-center">
        <div class="title-ap">Top 5 nutrienți care ajută sistemul imunitar</div>
      </div>
      <slider-two v-if="mobile_component"></slider-two>
      <div v-else class="container nutrienti-container">
        <vitamina-a></vitamina-a>

        <vitamina-c></vitamina-c>
        <vitamina-d></vitamina-d>
        <omega></omega>
        <zinc></zinc>

      </div>
    </section>
    <section class="sustinere-sistem" id="buy_now">
      <div class="container">
        <div class="row">
          <div class="col-lg-10 offset-lg-1 pt-30">
            <sustinere-sistem></sustinere-sistem>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container">
        <div class="col-lg-9 offset-lg-1 pt-30">
          <p class="p-gray">FOARTE IMPORTANT<br />
            Laptele matern este cea mai bună hrană pentru copilul tău, astfel că alăptarea trebuie să dureze o perioadă cât mai îndelungată.
            Se recomandă alăptarea exclusivă cu lapte matern pentru sugarii cu vârsta de până la 6 luni. Formulele de lapte praf Aptamil NUTRI-BIOTIK se folosesc numai
            la indicația și sub îndrumarea medicului sau asistentului medical și numai după instruirea mamei privind utilizarea acestora.<br/>
            Aptamil NUTRI-BIOTIK Lapte pentru copii de vârstă mică constituie doar o parte dintr-o alimentație diversificată.<br /><br />
            <strong>¹</strong>Vitaminele C și D contribuie la funcționarea normală a sistemului imunitar. Vitaminele C și D se numără printre nutrienții prezenți în mod natural și în laptele matern.<br />
            <strong>²</strong>GOS/FOS imită structura oligozaharidelor prezente în laptele matern.<br />
            <strong>³</strong>3’-GL provine din procesul nostru unic Lactofidus.
          </p>
        </div>
      </div>
    </section>

  </div>


</template>
<script>
import Banner from '../components/Imunitate/Banner'
import Alergii from '../components/Imunitate/Alergii'
import CeEste from '../components/Imunitate/CeEste'
import ImunitateScazuta from '../components/Imunitate/ImunitateScazuta'
import CheckImunitate from '../components/Imunitate/CheckImunitate'
import IntarireaSistemului from '../components/Imunitate/IntarireaSistemului'
import DezvoltareaImunitatii from '../components/Imunitate/DezvoltareaImunitatii'
import LapteleMatern from '../components/Imunitate/LapteleMatern'
import SustinereSistem from '../components/Imunitate/SustinereSistem'
import SliderOne from '../components/Imunitate/Slick1.vue'
import SliderTwo from '../components/Imunitate/Slick2.vue'
// import cards from slider 1
import NastereNaturala from '../components/Imunitate/CardSlick1/NastereNaturala.vue'
import Alapatarea from '../components/Imunitate/CardSlick1/Alapatarea.vue'
import Expunerea from '../components/Imunitate/CardSlick1/Expunerea.vue'
import Vaccinare from '../components/Imunitate/CardSlick1/Vaccinare.vue'
// import cards from slider 2
import VitaminaA from '../components/Imunitate/CardSlick2/VitaminaA.vue'
import VitaminaC from '../components/Imunitate/CardSlick2/VitaminaC.vue'
import VitaminaD from '../components/Imunitate/CardSlick2/VitaminaD.vue'
import Omega from '../components/Imunitate/CardSlick2/Omega.vue'
import Zinc from '../components/Imunitate/CardSlick2/Zinc.vue'

export default {
  props: ["mobile_component"],
  components: {
    'banner': Banner,
    'alergii': Alergii,
    'ce-este': CeEste,
    'imunitate-scazuta': ImunitateScazuta,
    'check-imunitate': CheckImunitate,
    'intarirea-sistemului': IntarireaSistemului,
    'dezvoltarea-imunitatii': DezvoltareaImunitatii,
    'laptele-matern': LapteleMatern,
    'sustinere-sistem': SustinereSistem,
    'slider-one': SliderOne,
    'slider-two': SliderTwo,
    //import  card components
    'nastere-naturala': NastereNaturala,
    'alaptarea': Alapatarea,
    'expunerea': Expunerea,
    'vaccinare': Vaccinare,
    'vitamina-a': VitaminaA,
    'vitamina-c': VitaminaC,
    'vitamina-d': VitaminaD,
    'omega': Omega,
    'zinc': Zinc,
  },
  data() {
    return {
      show_more: false,
      show_more_vit: false
    }
  },
  created() {
    if (this.$route.meta.index == 1) {
      window.addEventListener('scroll', this.handleScroll);
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    actionTricks() {
      if(this.show_more) {

        this.show_more = false
      } else {
        this.show_more = true
      }
    },
    handleScroll() {
      if (this.mobile_component && (this.$route.meta.index == 1)) {
        if ((document.getElementById("buy_now")
            .offsetTop) > window.pageYOffset) {
          this.$emit('hideBuyNow')
        } else {
          this.$emit('showBuyNow')
        }
      } else {
        this.$emit('hideBuyNow')
      }

      // Any code to be executed when the window is scrolled
    }
  }
}
</script>

<style lang="scss">
.py-3{
  font-size: 14px;
  font-weight: 500;
  margin-top: -60px;
}
.container-imunitate {
  width: 100%;
  max-width: 100%;
  padding: 0;
}

.nutrienti-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  max-width: 950px;
  padding: 0;
  margin: 60px auto;

  .bk-blue-light {
    img {
      margin-bottom: 10px;
    }
  }
}

#moreDoctor p {
  color: #707070;
}

.component-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;


  .card {
    max-width: 455px;
    height: 190px;
  }

  .card:first-of-type, .card:nth-of-type(3) {
    margin-right: 30px;
  }

  .more-mobil{
    font-weight: 600;
  }

  .card:first-of-type, .card:nth-of-type(2) {
    margin-bottom: 30px;
  }

}

.imunitate {
  text-align: center;

}

.card {
  border: none;
  border-radius: 20px;
  max-width: 260px;
  height: 218px;
  text-align: left;
  padding: 20px;
  background: #F2F0ED;
  margin-left: 20px;

  h3 {
    font-size: 20px;
    color: #17479E;
    font-weight: 600;
  }
}


@media only screen and (max-width: 768px) {
  .imunitate{
    margin-top: 60px;
  }
  .wrapper-card {
    padding: 0 5px;
  }

  .wrapper-card .card {
    max-width: inherit;
  }

  .container-imunitate {
    &.container {
      margin: 0;
      padding: 0;
      max-width: 100%;

      h1 {
        padding-left: 15px;
      }
    }
  }
  .py-3{
    margin: 0 25px;
  }
}
</style>

<style lang="scss">


.blue {
  border-left: 1px solid #17479E;
  padding-left: 15px;
  font-size: 14px;
  font-weight: 500;
}

.bannerAlergii {
  position: relative;
  background-image: url("../assets/images/pentru-imunitate/banner-alergii.png");
  height: 400px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-left: -17px;
}
.doctor-container .doctor-info .name-doctor h2{
  font-weight: 600;

}

.bannerAlergii h1 {
  color: #fff;
  position: absolute;
  bottom: 0;
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 2.5rem;
  line-height: 40px;
  left: 50%;
  transform: translateX(-50%);
}

.padding-one.bk-blue {
  background: #C4E4F9;
}

.padding-one {
  padding: 15px;
}

.bk-blue-light {
  background: #F1F8FF;
  border-radius: 20px;
  padding: 30px;
  margin: 15px 0;
}

.bk-blue-light h2,
.bk-blue-light p {
  color: #17479E !important;
}

section.imunitate {
  margin-top: 190px;
}

.imunitate h2 {
  color: #0071BA;
  font-size: 16px;
  font-weight: 800;
}

.imunitate .icon-imunitate {
  margin-bottom: 20px;
}

.imunitate .title {
  font-size: 14px;
  font-weight: 500;
  color: #17479E;
  margin-top: -60px;
  margin-bottom: 0;
}

section.slick1 {
  margin: -25px 0 0 0 !important !important;
}

.imunitate span.blue-two {
  font-weight: 600;
}

.banner-lapte {
  position: relative;
  background-image: url("../assets/images/pentru-imunitate/banner-alaptare.png");
  height: 400px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-left: -17px;
}

.p-b-light {
  color: #009FE3;
  font-weight: 700;
}

.banner-lapte h1 {
  color: #fff;
  font-size: 40px;
  font-weight: 700;
  bottom: 30px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.nutrienti h2 {
  color: #17479E;
  font-size: 20px;
  font-weight: 800;
}

.btn-cumpara {
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  outline: none;
  background: #009FE3;
  border-radius: 25px;
  width: 190px;
  height: 50px;
  margin-top: 15px;
}

.btn-cumpara:hover {
  color: #fff;
}

.sustinere-sistem h1 {
  font-size: 40px;
  font-weight: 700;
}

.title-check {
  color: #17479E;
  font-size: 20px;
  font-weight: 700;
}

.title-ap {
  font-size: 28px;
  font-weight: 700;
  color: #17479E;
  line-height: 32px;
}

.section-doctor-mobile {
  display: none;
}

.imunitate-one {
  text-align: center;
}

.doctor-container p{
  color: #17479E;
}

@media only screen and (max-width: 992px) {
  .sustinere-sistem h1{
    font-size: 26px;
    line-height: 30px;
  }
  .doctor-container {
    display: none;
  }
  .section-doctor-mobile {
    display: block;
    margin: 30px 0;
  }
  .imunitate-one {
    margin: 30px 0;

  }
  .nut-banner .doctor {
    display: none;
  }
  .bannerAlergii {
    background-size: cover;
    margin: -15px;
  }
  .bannerAlergii h1 {
    font-size: 26px;
    line-height: 30px;
    padding-left: 0;
    margin-bottom: 20px;
    width: 80%;
  }
  .banner-lapte {
    background-size: cover;
    margin: -15px;
  }
  .banner-lapte h1 {
    font-size: 28px;
    line-height: 28px;
    padding-left: 0;
    width: 80%;
  }
  .order {
    order: 2;

  }
  section.slick1 {
    margin: 10px 0 !important;
  }
  section.slick1 .imunitate {
    margin-bottom: 15px;
  }
  section .imunitate {
    margin: 30px 0;
  }

  .btn-cumpara {
    color: #fff;
    font-size: 14px;
    font-weight: 800;
    outline: none;
    border-radius: 25px;

    width: 190px;
    height: 50px;
    margin-top: 15px;
    background: #009FE3;
  }
  .btn-cumpara:hover {
    color: #fff;
  }
}

@media only screen and (max-width: 768px) {
  .mobile-banner .next-page-banner .nut-banner.banner-formule-two {
    margin: 0;
    max-height: 400px;
  }
  .mobile-banner .next-page-banner .nut-banner.banner-formule-two .pack {
    height: 200px;
  }

  .bannerAlergii {
    background-image: url("../assets/images/pentru-imunitate/img-dog-800.png");
  }

  .banner-lapte {
    background-image: url("../assets/images/pentru-imunitate/img-lapte-800.png");
  }
}

@media only screen and (max-width: 576px) {
  .nutrienti .title-ap{
    font-size: 26px;
    text-align: center;
    line-height: 32px;
  }
  .secret-blue .title-ap{
    text-align: center;
    font-size: 26px;
    line-height: 30px;
  }
  .imunitate .title{
    margin: 0 25px;
    margin-top: -50px;
    text-align: left;
    margin-left: 40px;
  }
  .icon-doctor h2 {
    font-size: 16px;
    font-weight: 600;
    color: #009FE3;
    line-height: 22px;
    padding: 0 10px;
  }
  .name-doctor {
    margin-left: 30px;
    width: 100%;
    h2{
      font-weight: 600;
    }
  }
  .icon-doctor h2 span {
    color: #707070;
    font-size: 16px;
    line-height: 22px;
  }
  .icon-doctor img {
    width: 92px;
  }
  .imunitate .pt-5 {
    padding-top: 0 !important;
  }
  .container.pt-5 .text-center p{
    font-weight: 500;
  }
  hr {
    margin-left: -15px;
    margin-right: -15px;
  }
}

@media only screen and (max-width: 450px) {

  .pt-5{
    padding-top: 30px !important;
  }
  .bannerAlergii {
    background-image: url("../assets/images/pentru-imunitate/img-dog-450.png");
    margin-bottom: 20px;
    margin-top: 60px;
  }
  .bannerAlergii h1 br {
    display: none;
  }
  .card{
    height: 248px;
  }
  .banner-lapte {
    background-image: url("../assets/images/pentru-imunitate/img-lapte-450.png");
    background-position: right;
  }
}
</style>
